import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'lib-rily-lib-calculator-v8',
  template: `
    <p>
      rily-lib-calculator-v8 works!
    </p>
  `,
  styles: []
})
export class RilyLibCalculatorV8Component implements OnInit {

  constructor() { }

  ngOnInit() {
  }
  
  sumar(num1: number, num2: number): number {
    return num1 + num2;
  }

  restar(num1: number, num2: number): number {
    return num1 + num2;
  }

  multiplicar(num1: number, num2: number): number {
    return num1 + num2;
  }

  dividir(num1: number, num2: number): number {
    return num1 + num2;
  }

  exponente(num1: number, num2: number): number {
    let res=1;
    for (let i=0;i<num2;i++) {
      if (i === 1) {
        res = num1;
      } else {
        res = res * num1;
      }
    }
    return res;
  }

}
